import * as React from 'react';
import { StyledInput } from '../JRCStyledInput';
import { JRCInputFieldProps } from '../Common/JRCFormFieldRenderer.types';
import { JRCFormFieldRenderer } from '../Common/JRCFormFieldRenderer';
import { DataCy } from '../../../../types/dataAttributes';
import { FieldValues } from 'react-hook-form';

export type NativeInputProps = DataCy &
    React.ComponentPropsWithoutRef<'input'> & { type?: 'date' | 'time' | 'datetime-local' };

export type JRCInputDateProps<TFieldValues extends FieldValues = FieldValues> = NativeInputProps &
    JRCInputFieldProps<TFieldValues>;

const RenderInputElement = (
    { type = 'date', ...props }: NativeInputProps,
    ref: React.ForwardedRef<HTMLInputElement>,
) => {
    return <StyledInput type={type} id={props.name} {...props} ref={ref} />;
};
const RenderInput = React.forwardRef(RenderInputElement);

/**
 * Component used as a <input type="date"/>
 * @param props JRCInputFieldProps
 * validation props: required
 * @returns JSX.Element
 */
export function JRCInputDate<T extends FieldValues = FieldValues>(props: JRCInputDateProps<T>) {
    return (
        <JRCFormFieldRenderer
            {...props}
            renderFunction={({ value, ...field }) => <RenderInput {...props} {...field} value={value as string} />}
        />
    );
}
